import { render, staticRenderFns } from "./supplierBank.vue?vue&type=template&id=d496b2e6&scoped=true"
import script from "./supplierBank.vue?vue&type=script&lang=js"
export * from "./supplierBank.vue?vue&type=script&lang=js"
import style0 from "./supplierBank.vue?vue&type=style&index=0&id=d496b2e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d496b2e6",
  null
  
)

export default component.exports